import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <div style={{ fontSize: '72px', fontWeight: 700, color: 'rgba(255,255,255,0.05)', marginBottom: '16px' }}>404</div>
        <div style={{ fontSize: '20px', fontWeight: 600, color: '#ffffff', marginBottom: '8px' }}>Page not found</div>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '28px', lineHeight: 1.6 }}>
          The page you are looking for does not exist.<br />
          Let's get you back to learning.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Link to="/" style={{ fontSize: '13px', padding: '10px 20px', borderRadius: '10px', backgroundColor: '#10b981', color: '#ffffff', textDecoration: 'none' }}>
            Go home
          </Link>
          <Link to="/learn/01/01" style={{ fontSize: '13px', padding: '10px 20px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.05)', color: '#9ca3af', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.1)' }}>
            Start learning
          </Link>
        </div>
      </div>
    </div>
  );
}